import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LocalizedLink } from "../../lib/i18nRouting";
import { HOLIDAYS_PATH, HOLIDAY_IMAGES } from "../../data/holidays";
import Reveal from "../Reveal";
import { useEarlyBird } from "../../lib/useEarlyBird";

export default function HolidaysBanner() {
  const { t } = useTranslation();
  const eb = useEarlyBird();
  return (
    <section className="bg-bone py-6 lg:py-8" data-testid="holidays-banner">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <LocalizedLink
            to={HOLIDAYS_PATH}
            data-testid="holidays-banner-link"
            className="group relative block overflow-hidden bg-forest-deep text-bone"
          >
            <img
              src={HOLIDAY_IMAGES.final}
              alt=""
              loading="lazy"
              decoding="async"
              className="absolute inset-0 w-full h-full object-cover opacity-40 cine-img"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-forest-deep via-forest-deep/80 to-forest-deep/30" />
            <div className="absolute inset-0 grain pointer-events-none" />
            <div className="relative grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-center px-7 py-8 lg:px-12 lg:py-10">
              <div className="md:col-span-8">
                <div className="text-[10px] uppercase tracking-wider-3 text-terracotta">{t("holidays_banner.eyebrow")}</div>
                <div className="font-display text-3xl sm:text-4xl lg:text-5xl leading-tight mt-2" data-testid="holidays-banner-title">
                  {t("holidays_banner.title")}
                </div>
                <p className="mt-3 text-sm md:text-base text-bone/75 max-w-2xl leading-relaxed">{t("holidays_banner.sub")}</p>
                {eb.active && <span className="mt-4 inline-flex items-center gap-2 border border-terracotta/70 text-terracotta text-[10px] uppercase tracking-wider-2 px-3 py-1.5" data-testid="holidays-banner-early-bird">
                  {t("holidays_banner.badge")}
                </span>}
              </div>
              <div className="md:col-span-4 md:justify-self-end">
                <span className="btn-lift inline-flex items-center gap-3 bg-bone text-forest px-7 py-4 text-xs uppercase tracking-wider-3 group-hover:bg-bone-deep transition-colors">
                  {t("holidays_banner.cta")} <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </div>
          </LocalizedLink>
        </Reveal>
      </div>
    </section>
  );
}
